import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-red-500">Matter King</h3>
            <p className="text-gray-300">The CRM that helps you build lasting customer relationships</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#home" className="hover:text-red-500">Home</a></li>
              <li><a href="#about" className="hover:text-red-500">About</a></li>
              <li><a href="#services" className="hover:text-red-500">Services</a></li>
              <li><a href="/policy/privacy" className="hover:text-red-500">Privacy Policy</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <p className="text-gray-300">info@matterking.com</p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 Matter King, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
